import Api from '../http.service';
/**
 * search Flight (from all gateways)
 * @param {Object} payload
 * @param {String} payload.businessTypes
 */
export const fetchBusinesstype = (payload) =>
  Api.GET({ url: `license/business_type/${payload.businessTypes}` });

export const getAllLicenseType = () => Api.GET({ url: `license/all` });
